import { AiFillDashboard, AiOutlineUser } from "react-icons/ai";
import { FaMobileAlt } from "react-icons/fa";

export const SidebarNav = [
  {
    type: "main",
    title: "Dashboard",
    icon: (
      <AiFillDashboard
        className={`w-6 h-6   transition-all duration-500 ease-out`}
      />
    ),
    path: "/",
  },
  {
    type: "separator",
    title: "Devices",
  },
  {
    type: "button",
    title: "My Devices",
    icon: (
      <FaMobileAlt
        className={`w-6 h-6 shrink-0  transition-all duration-500 ease-out`}
      />
    ),
    path: "/devices",
  },
  { type: "separator", title: "Account" },
  {
    type: "button",
    title: "Profile",
    icon: (
      <AiOutlineUser
        className={`w-6 h-6   transition-all duration-500 ease-out`}
      />
    ),
    path: "/profile",
  },
];
